/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* ==========================================================================
   FIX CARRITO MOVIL (iPhone + barra de regalos lb-cart-progress-bar)
   1) Layout del carrito en columna flexible con altura real de pantalla
      (100dvh) en vez del max-height calculado por el tema, que en iPhone
      queda mal cuando se mueve la barra de Safari/WhatsApp.
   2) Compacta la barra de regalos y la mueve DENTRO de la zona desplazable.
   3) Evita que el bloqueo de scroll del tema (disableBodyScroll de Prestige)
      u otras apps cancelen el deslizamiento dentro del carrito en iOS.
   ========================================================================== */
(function () {
  var MOBILE = '(max-width: 749px)';
  var MAIN_SEL = '#sidebar-cart .Drawer__Main';

  var css =
    '@media screen and (max-width: 749px){' +
    '#sidebar-cart.Drawer{display:flex !important;flex-direction:column !important;height:100vh;height:100dvh;}' +
    '#sidebar-cart .Drawer__Header{flex:0 0 auto !important;}' +
    '#sidebar-cart .Drawer__Content{max-height:none !important;flex:1 1 0 !important;min-height:0 !important;}' +
    '#sidebar-cart .Drawer__Main{flex:1 1 0 !important;min-height:0 !important;overflow-y:auto !important;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-y;}' +
    '#sidebar-cart .Drawer__Footer{flex:0 0 auto !important;}' +
    '#sidebar-cart .lb-cpb-progress-text-wrapper{margin:0 !important;}' +
    '#sidebar-cart .lb-cpb-cart-goal-title-text{font-size:10px !important;line-height:1.2 !important;display:-webkit-box !important;-webkit-line-clamp:2 !important;-webkit-box-orient:vertical !important;overflow:hidden !important;}' +
    '#sidebar-cart .lb-cpb-gift-product-link{height:auto !important;}' +
    '}';
  var style = document.createElement('style');
  style.id = 'holix-cart-mobile-fix';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  var mq = window.matchMedia(MOBILE);

  // Deja pasar el deslizamiento dentro del carrito: corta la propagacion del
  // touchmove antes de que llegue al listener del tema que hace preventDefault.
  function allowCartScroll(e) {
    if (!e.target || !e.target.closest) return;
    var main = e.target.closest(MAIN_SEL);
    if (main && main.scrollHeight > main.clientHeight) {
      e.stopPropagation();
    }
  }
  document.addEventListener('touchmove', allowCartScroll, { capture: true, passive: true });
  document.addEventListener('touchstart', allowCartScroll, { capture: true, passive: true });

  function moveBar() {
    if (!mq.matches) return;
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    var main = drawer.querySelector('.Drawer__Main');
    var bar = drawer.querySelector('lb-cart-progress-bar');
    if (!main || !bar || bar.parentNode === main) return;
    main.insertBefore(bar, main.firstChild);
  }

  function start() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    moveBar();
    new MutationObserver(moveBar).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
